import type {
  BlockerCreateOutputs,
  BlockerCreateStepId,
  BlockerCreateWorkflowEvent,
} from "../_shared/_logic/create-blocker-contract"

export const blockerCreateStepIndex = (step: BlockerCreateStepId): number =>
  ["general", "configuration", "details"].indexOf(step)

export const applyBlockerCreateWorkflowEvent = (
  outputs: BlockerCreateOutputs,
  event: BlockerCreateWorkflowEvent,
): BlockerCreateOutputs => {
  if (event.type === "general.completed") return { general: event.output }

  if (event.type === "configuration.completed") return { ...outputs, configuration: event.output }

  return outputs
}

export const nextBlockerCreateStep = (
  current: BlockerCreateStepId,
  event: BlockerCreateWorkflowEvent,
): BlockerCreateStepId => {
  if (event.type === "go_to_step") return event.step

  if (event.type === "general.completed") return "configuration"

  if (event.type === "configuration.completed") return "details"

  return current
}
